import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  Typography,
  InputLabel,
} from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

export function ColorSelectDialog({
  open,
  colors,
  selectedColor,
  onClose,
  onSelectColor,
  activities,
  onSelectColorActivity,
  selectedColorActivity
}) {
  const [current, setCurrent] = React.useState(selectedColor);

  React.useEffect(() => {
    setCurrent(selectedColor);
  }, [selectedColor]);

  const onClickSelect = () => {
    if (selectedColorActivity === "XX") {
        alert("Please select an activity.");
        return null;
    }
    return current && onSelectColor(current);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Select a Color for an Activity</DialogTitle>

      <DialogContent>
        <InputLabel>Select Activity *:</InputLabel>
        <Select
          sx={{ mb: 1 }}
          fullWidth
          size="small"
          onChange={onSelectColorActivity}
          value={selectedColorActivity}
        >
          <MenuItem key="XX" value="XX">
            -- SELECT --
          </MenuItem>
          {activities.map((activity) => (
            <MenuItem key={activity.eid} value={activity.eid}>
              {activity.name}
            </MenuItem>
          ))}
        </Select>
        <InputLabel sx={{mt:2}}>Select Color *:</InputLabel>
        <Grid container spacing={2} sx={{ mt: 0 }}>
          {colors.map((color) => (
            <Grid item xs={3} key={color}>
              <Box
                onClick={() => setCurrent(color)}
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  backgroundColor: color,
                  cursor: "pointer",
                  border:
                    current === color ? "3px solid #9e9e9e" : "1px solid #ccc",
                  boxSizing: "border-box",
                }}
              />
            </Grid>
          ))}
        </Grid>

        {current && (
          <Typography
            variant="caption"
            sx={{ display: "block", mt: 2, textAlign: "center" }}
          >
            Selected: {current}
          </Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!current}
          onClick={onClickSelect}
        >
          Select
        </Button>
      </DialogActions>
    </Dialog>
  );
}
